import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00be5d08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popupbox" }
const _hoisted_2 = { class: "popupbox-toolbar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popupboxtitle" }, "参见单位", -1))
const _hoisted_4 = { class: "popupbox-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    round: "",
    position: "bottom",
    show: _ctx.showPopup,
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showPopup) = $event)),
    style: { height: '95%' },
    closeable: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_van_search, {
            modelValue: _ctx.searchValue,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
            "show-action": "",
            placeholder: "请输入搜索关键词",
            onSearch: _ctx.fSearch
          }, {
            action: _withCtx(() => [
              _createElementVNode("div", {
                style: {"color":"#1989fa"},
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fSearch && _ctx.fSearch(...args)))
              }, "搜索")
            ]),
            _: 1
          }, 8, ["modelValue", "onSearch"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_pull_refresh, {
            modelValue: _ctx.refreshing,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.refreshing) = $event)),
            onRefresh: _ctx.onRefresh
          }, {
            default: _withCtx(() => [
              _createVNode(_component_van_list, {
                loading: _ctx.loading,
                "onUpdate:loading": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loading) = $event)),
                finished: _ctx.finished,
                "finished-text": "没有更多了",
                "loading-text": "正在加载,请稍后..",
                onLoad: _ctx.onLoad
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_cell_group, null, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.canjianList, (item) => {
                        return (_openBlock(), _createBlock(_component_van_cell, {
                          key: item.id,
                          title: item.name,
                          clickable: "",
                          onClick: ($event: any) => (_ctx.fSelectCompany(item))
                        }, null, 8, ["title", "onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["loading", "finished", "onLoad"])
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}